import _functionCall from "../internals/function-call";
import _anObject from "../internals/an-object";
import _getMethod from "../internals/get-method";
var exports = {};
var call = _functionCall;
var anObject = _anObject;
var getMethod = _getMethod;
exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, "return");
    if (!innerResult) {
      if (kind === "throw") throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === "throw") throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};
export default exports;